import { FC } from 'react';
import { ZeroBeta } from './ZeroBeta';

export const Disclaimer: FC = () => (
  <div className="grid relative grid-cols-[auto_1fr] col-span-3 mt-8 gap-4 items-start">
    <ZeroBeta />
    <div className="grid relative gap-4 text-[#96DFFF] text-[12px]">
      Results are AI generated and may include errors. Do not invest based on
      information you see here.
    </div>
  </div>
);
